import { Tooltip } from '@material-ui/core';
import { navigateBookDemoClick } from 'common/utils/utils';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import startCase from 'lodash/startCase';
import withGitIntegrationsModals from '../gitIntegrations/withGitIntegrationsModals';
import OnPremTitle from './OnPremiseAgent';
import { LBButton } from '@linearb/buzz';

const addRepositoriesButtonTooltip = (name, sensorName) => (
  <Text size='medium' color='chambray'>{`Add more repositories from ${startCase(
    name || sensorName
  )}.`}</Text>
);

const AddRepositoryButton = ({
  stateOK,
  canAddMoreRepos,
  isTeamLicense,
  openRepositoriesModal,
  sensor_name,
  integrationId,
  name,
  is_on_prem
}) => {
  const openRepositoriesModalProps = {
    sensorAuth: { id: integrationId, name, sensor_name },
    isAddIntegrationFlow: false
  };

  return stateOK ? (
    <Tooltip
      data-testid='button-tooltip'
      title={addRepositoriesButtonTooltip(name, sensor_name)}
      placement='top-start'
      disableHoverListener={is_on_prem || !canAddMoreRepos}
    >
      {is_on_prem ? (
        <OnPremTitle />
      ) : (
        <LBButton
          startIcon={<Icon name='add' color='chambray' />}
          size='sm'
          variant='outline'
          data-cy='add-repositories-button'
          onClick={e => {
            e.stopPropagation();
            if (canAddMoreRepos) {
              openRepositoriesModal({ ...openRepositoriesModalProps });
              return;
            }
            navigateBookDemoClick();
          }}
          disabled={is_on_prem}
        >
          {canAddMoreRepos
            ? 'Add Repositories'
            : 'Upgrade to add more repositories'}
        </LBButton>
      )}
    </Tooltip>
  ) : (
    <></>
  );
};

export default withGitIntegrationsModals(AddRepositoryButton);
